// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"281":"36c04580","404":"ac9721d3","718":"dd1d6386"}[chunkId] + ".js";
};